import React from 'react'

import { Colors, Breakpoints } from './../../utils/variables'

class BackgroundDots extends React.Component {

    constructor(props) {

        super(props)

        this.canvasRef = React.createRef();
        this.updateDimenions = this.updateDimenions.bind(this);
    }

    componentWillMount() {
        
        if (typeof window !== 'undefined') {
            this.setState({
                width: window.innerWidth,
                height: window.innerHeight
            })
        }

    }

    componentDidMount() {

        window.addEventListener('resize', this.updateDimenions)
        
        this.updateDimenions();

    }

    componentDidUpdate() {

        const dots = this.props.data;      
        const canvas = this.canvasRef.current;
        const ctx = canvas.getContext('2d');
        const ratio = window.devicePixelRatio || 1;

        canvas.width = this.state.width * ratio;
        canvas.height = this.state.height * ratio;
        canvas.style.width = this.state.width + 'px';
        canvas.style.height = this.state.height + 'px';

        ctx.scale(ratio, ratio);
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        
        for (let i = 0; i < dots.length; i++) {

            let xPos = dots[i].mobile.position === 'left' ? dots[i].mobile.x : (canvas.width - dots[i].mobile.x) / ratio;
            let yPos = dots[i].mobile.y;
            let circle = dots[i].mobile.circle;
            let ellipse = dots[i].mobile.ellipse;

            if (this.state.width > parseInt(Breakpoints.wide)) {
                xPos = dots[i].desktop.position === 'left' ? dots[i].desktop.x : (canvas.width - dots[i].desktop.x) / ratio;
                yPos = dots[i].desktop.y;
                circle = dots[i].desktop.circle;
                ellipse = dots[i].desktop.ellipse;
            }

            ctx.beginPath();
            ctx.arc(xPos, yPos, circle, 0, 2 * Math.PI);
            ctx.lineWidth = 1;
            ctx.strokeStyle = 'rgba(18, 20, 83, 0.2)';
            ctx.stroke();

            ctx.beginPath();
            ctx.arc(xPos, yPos, ellipse, 0, 2 * Math.PI);
            ctx.fillStyle = Colors.blue;
            ctx.fill();

        }

    }

    componentWillUnmount() {

        window.removeEventListener('resize', this.updateDimenions);

    }

    updateDimenions() {

        const width = document.body.clientWidth;
        const height = document.body.clientHeight;

        this.setState({ width, height });

    }

    render() {
        return (
            <canvas 
                ref={this.canvasRef} 
                style={{ 
                    position: 'absolute', 
                    top: 0, 
                    left: 0,
                    zIndex: -1
                }} 
            />
        )
    }

}

export default BackgroundDots